var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOsuuspankki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-252.04724,-406.18109)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98999999,
      color: "#000000",
      fill: "#ff6a10",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    },
    d: "m 396.21005,644.57494 c 33.77186,-7.24626 63.8132,-29.3338 80.46627,-59.16188 19.48836,-34.90648 20.49817,-76.66481 2.72681,-112.75746 -6.57833,-13.36021 -13.59332,-22.88679 -24.52485,-33.30565 -14.87179,-14.17429 -32.97911,-24.30596 -52.90057,-29.59969 -14.25863,-3.78894 -36.8313,-4.70208 -50.89066,-2.05874 -46.60543,8.76247 -84.082,43.53595 -95.94516,89.02489 -2.94497,11.29239 -4.05871,36.3713 -2.14691,48.34373 7.88701,49.39178 46.02958,89.20573 95.45487,99.63767 9.63481,2.03357 38.05057,1.96047 47.7602,-0.12287 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98999999,
      color: "#000000",
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    },
    d: "m 358.73056,480.16934 c -47.02914,-24.01776 -82.55011,16.20474 -80.5411,46.44353 0.20411,38.15307 41.28113,66.43983 80.5411,45.77174 l 0,47.91173 25.18311,-0.0923 0.39887,-48.0112 c 49.4987,23.34318 82.25396,-16.03467 81.66587,-45.56854 -0.60787,-38.09437 -38.74546,-67.74357 -81.66587,-46.45505 l 0,-48.10342 -24.85652,0 z m -26.61168,18.09986 c 40.27632,4.50795 32.86842,55.81119 -0.14812,56.59041 -38.90523,-0.95785 -38.80581,-56.59584 0.14812,-56.59041 z m 82.56125,-0.80272 c 37.46728,4.21587 33.12602,56.35719 -1.77811,57.39546 -42.8389,-5.61331 -34.10622,-58.42089 1.77811,-57.39546 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsuuspankki);
export default __webpack_public_path__ + "static/media/osuuspankki.464040f29f6cf74c0230d64c825f6632.svg";
export { ForwardRef as ReactComponent };